import { TransactionWithdrawDetailsViewModel } from "@payping/api";
import { CLEAR_LIST, LOGGED_OUT } from "./constants";
import { ClearListAction, LoggedOutAction } from "./types";

export const WITHDRAWS_LOADED = "WITHDRAWS_LOADED";
export const SET_BALANCE = "SET_BALANCE";

export interface WithdrawState {
  balance: number;
  list: TransactionWithdrawDetailsViewModel[];
  totalCount: number;
  paginationEnd: boolean;
}

export interface WithdrawsLoadedAction {
  type: typeof WITHDRAWS_LOADED;
  payload: { list: TransactionWithdrawDetailsViewModel[]; totalCount: number; append: boolean };
}

export interface SetBalanceAction {
  type: typeof SET_BALANCE;
  payload: number;
}

export type WithdrawActionTypes = WithdrawsLoadedAction | ClearListAction | LoggedOutAction | SetBalanceAction;

const initialState: WithdrawState = {
  balance: 0,
  list: [],
  paginationEnd: false,
  totalCount: 0,
};

export default function withdraws(state = initialState, action: WithdrawActionTypes): WithdrawState {
  if (action.type === WITHDRAWS_LOADED) {
    const { list, totalCount, append } = action.payload;
    const newList = append ? [...state.list, ...list] : list;
    return {
      ...state,
      list: newList,
      paginationEnd: !list.length || newList.length >= totalCount,
      totalCount,
    };
  }

  if (action.type === CLEAR_LIST) {
    return {
      ...state,
      list: [],
    };
  }

  if (action.type === LOGGED_OUT) {
    return initialState;
  }

  if (action.type === SET_BALANCE) {
    return { ...state, balance: action.payload };
  }

  return state;
}
